import pro1 from "../assets/project-2.jpg" //canteen
import pro2 from "../assets/project-1.png" //train
import pro3 from "../assets/project-3.jpg" //ITS

const ProjectCardData = [
    {
        imgsrc : pro1,
        title : "Digitalise Canteen",
        text:"The Digitalised Canteen project aims to develop a digital solution for managing canteen operations efficiently. This system facilitate seamless ordering, payment, and management of food items in a canteen environment. ",
        view: "https://github.com/binay987/canteen-mngmt-system"

    },
    {
        imgsrc : pro2,
        title : "Train Game",
        text:"The Train Game project demonstrates the effective use of the SFML library and C++ programming language to create a fun and engaging game and showcases the power of linked lists as a valuable data structure for game development.",
        view: "https://github.com/binay987/Train-Game-Final"

    },
    {
        imgsrc : pro3,
        title : "Intelligent Traffic System",
        text:"This project focuses on traffic signal simulation and optimization using video feeds from intersection cameras for real-time traffic density calculations and vehicle detection through the YOLO algorithm",
        view: "" //link in future 

    },
    
];

export default ProjectCardData;